<template>
    <div class="view view__report_dashboard_show">
        <report-dashboard-show></report-dashboard-show>
    </div>
</template>

<script>

import ReportDashboardShow from '@/components/ebs/reports/dashboard/show/ReportDashboardShow'

export default {
  name: 'view-report-dashboard',
  components: { ReportDashboardShow }
}
</script>
